const auth_status = {
    page_title: 'Estado de autenticação',
    title: 'Estado de autenticação',
    description: 'Verificar o estado da autenticação.',
};
export default Object.freeze(auth_status);
